var React = require('react');
var ReactNative = require('react-native');


var Hyperlink = require('./wrappers/react-native-hyperlink-wrapper');
var LinkingManager = require('./wrappers/LinkingManager');
var Animated = require('./wrappers/Animated')

var Icon = require('./wrappers/ReUpIcon');

var NetworkManager = require('./NetworkManager');
var Globals = require('./Globals');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpText = require('./ReUpText');
var ReUpIconButton = require('./ReUpIconButton');
var moment = require('moment');

var {
  AppRegistry,
  Text,
  View,
  Image,
  StyleSheet,
  Platform
} = ReactNative;

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKButton,
} = MK;

var Promotions = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      features : [],
      Instagrams : [],
      Twitter : [],
    }
  },

  componentDidMount : function()
  {
    var thisThing = this;
    this.props.appManager.getDataType("Features", function(data)
    {
      thisThing.didUpdate(data);
    })
  },

  didUpdate : function(data)
  {
    if( typeof data === 'undefined' )
    {
      var thisThing = this;
      this.props.appManager.getDataType("Features", function(data)
      {
        thisThing.setState({features:data == null ? [] : data});
      })
      return;
    }

    if(typeof data.Features !== 'undefined' )
    {
      this.setState({features:data.Features == null ? [] : data.Features});
    }

    if(typeof data.Instagrams !== 'undefined')
    {
      this.setState({Instagrams: data.Instagrams == null ? [] : data.Instagrams});
    }

    if(typeof data.Twitter !== 'undefined')
    {
      this.setState({Twitter: data.Twitter == null ? [] : data.Twitter});
    }
  },

  _scrolledToItem:false,
  didRenderNewsItem:function(feature, offset)
  {
    if( typeof this.props.extras === 'undefined'
      || typeof this.props.extras.featureID === 'undefined'
      || this.props.extras.featureID != feature.FeatureID ) return;

    if( this._scrolledToItem ) return;
    this._scrolledToItem = true;

    this._ref_ptr.scrollTo(0, offset);
  },

  didSelectInstagram: function(url)
  {
    var barTintColor = this.props.appManager.getColorForKey("HeaderColor");
    var tintColor = this.props.appManager.getColorForKey("HeaderIconColor");
    LinkingManager.openURL(url, tintColor, barTintColor);
  },

  render: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = appManager.currentUser();

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
    var rippleColor = appManager.getColorForKey("FeedCardBannerColor", 0.2);

    var features = this.state.features.sort(function(a,b)
    {
      return appManager.getTime(b.Timestamp) - appManager.getTime(a.Timestamp);
    });

    var instagramPosts = this.state.Instagrams.sort(function(a,b)
    {
      return b.created_time - a.created_time;
    });

    var twitterPosts = this.state.Twitter.sort(function(a,b)
    {
      return b.created_time - a.created_time;
    });

    var facebookFeature = appManager.getFeatureForName("Facebook");
    var twitterFeature = appManager.getFeatureForName("Twitter");
    var instagramFeature = appManager.getFeatureForName("Instagram");

    var showSocialMedia = (typeof facebookFeature !== 'undefined' || typeof twitterFeature !== 'undefined' || typeof instagramFeature !== 'undefined') && (typeof this.props.featureData.hideSocialMedia === 'undefined' || !this.props.featureData.hideSocialMedia);

    var compiledFeatures = [];
    for( var i = 0; i < features.length; i++ ) compiledFeatures.push(features[i]);
    for( var i = 0; i < instagramPosts.length; i++ )
    {
      instagramPosts[i].isInstagram = true;
      compiledFeatures.push(instagramPosts[i]);
    }
    for( var i = 0; i < twitterPosts.length; i++ )
    {
      twitterPosts[i].isTwitter = true;
      compiledFeatures.push(twitterPosts[i]);
    }

    compiledFeatures = compiledFeatures.sort(function(a,b)
    {
      var aTime = 0;
      if( a.isInstagram ) aTime = a.created_time;
      else if( a.isTwitter ) aTime = (new Date(a.created_at)).getTime()/1000;
      else aTime = appManager.getTime(a.Timestamp)/1000;

      var bTime = 0;
      if( b.isInstagram ) bTime = b.created_time;
      else if( b.isTwitter ) bTime = (new Date(b.created_at)).getTime()/1000;
      else bTime = appManager.getTime(b.Timestamp)/1000;

      return bTime - aTime;
    })

    // get image dimensions
    var width = this.state.layout.width - 30;
    var ratio = 400.0 / 640.0; // height / width
    var height = width * ratio;

    return (
      <View style={[styles.container,{backgroundColor:generalColor}]}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
          {
            showSocialMedia ?
              <View style={{height:60, width:this.state.layout.width}} />
            : null
          }
        <ReUpScrollView ref={(c) => { this._ref_ptr = c; }} bounces={true} responder={this} isEmpty={compiledFeatures.length <= 0} featureName="Promotions">
          {
            compiledFeatures.map(function(feature, index)
            {
              if( feature.isInstagram )
              {
                var post = feature;
                var url = post.images.low_resolution.url;
                var shouldShowCaption = typeof post.caption !== 'undefined' && post.caption != null;

                return (
                  <MKButton
                    onPress={() => {thisThing.didSelectInstagram(post.link)}}
                    underlayColor={generalColor}
                    rippleColor={rippleColor}
                    maskBorderRadius={0}
                    onLayout={(info) =>
                      {
                        var layout = info.nativeEvent.layout;
                        this.props.cardHeight(layout.height);
                      }}
                      key={url}>
                    <View key={url}>
                      <View style={{margin: 5, marginLeft: 15, marginRight: 15}}>
                        <Image style={[styles.featureImage, {height}]} source={{uri: url}}/>
                        <View style={{flexDirection: 'row', alignItems: 'flex-start', marginTop: 10, marginBottom: 5}}>
                          <Icon name='instagram' size={20}/>
                          <View style={{flexDirection: 'column', flex: 1, marginLeft: 10}}>
                            {
                              shouldShowCaption ?
                                <ReUpText appManager={appManager} style={[styles.featureDescription, {color:generalTitleColor}]}>
                                  {post.caption.text.substr(0, 120).replace(/\n/g, " ") + '...'}
                                </ReUpText>
                              : null
                            }
                            <ReUpText appManager={appManager} style={{color:generalTitleColor, fontSize: 12, marginTop: shouldShowCaption ? 10 : 3}}>
                              {moment.unix(post.created_time).format("MM/DD/YYYY")}
                            </ReUpText>
                          </View>
                        </View>
                      </View>
                      <View style={[styles.divider, {backgroundColor: 'grey', marginLeft: 5, marginRight: 5}]} />
                    </View>
                  </MKButton>
                )
              }
              else if( feature.isTwitter )
              {
                var post = feature;
                if( typeof post.entities.media === 'undefined' || post.entities.media.length <= 0 )
                {
                  return (
                    <View key={feature.text}>
                      <View style={{margin: 5, marginLeft: 15, marginRight: 15}}>
                        <View style={{flexDirection: 'row', alignItems: 'flex-start', marginTop: 10, marginBottom: 5}}>
                          <Icon name='twitter' size={20}/>
                          <View style={{flexDirection: 'column', flex: 1, marginLeft: 10}}>
                            <ReUpText appManager={appManager} style={[{color:generalTitleColor}]}>
                              {feature.text}
                            </ReUpText>
                            <ReUpText appManager={appManager} style={{color:generalTitleColor, fontSize: 12, marginTop: 10}}>
                              {moment(new Date(post.created_at)).format("MM/DD/YYYY")}
                            </ReUpText>
                          </View>
                        </View>
                      </View>
                      <View style={[styles.divider, {backgroundColor: 'grey', marginLeft: 5, marginRight: 5}]} />
                    </View>
                  )
                }

                var url = post.entities.media[0].media_url_https;
                return (
                  <View key={url}>
                    <View style={{margin: 5, marginLeft: 15, marginRight: 15}}>
                      <Image style={[styles.featureImage, {height}]} source={{uri: url}}/>
                      <View style={{flexDirection: 'row', alignItems: 'flex-start', marginTop: 10, marginBottom: 5}}>
                        <Icon name='twitter' size={20}/>
                        <View style={{flexDirection: 'column', flex: 1, marginLeft: 10}}>
                          <ReUpText appManager={appManager} style={[styles.featureDescription, {color:generalTitleColor}]}>
                            {post.text.substr(0, 120).replace(/\n/g, " ") + '...'}
                          </ReUpText>
                          <ReUpText appManager={appManager} style={{color:generalTitleColor, fontSize: 12, marginTop: 10}}>
                            {moment.unix(post.created_time).format("MM/DD/YYYY")}
                          </ReUpText>
                        </View>
                      </View>
                    </View>
                    <View style={[styles.divider, {backgroundColor: 'grey', marginLeft: 5, marginRight: 5}]} />
                  </View>
                )
              }
              else
              {
                if( feature.IsDeleted == "1" ) return null;
                if( feature.IsDisabled == "1" ) return null;

                var url = feature.ImageFileName;
                if( typeof feature.ImageFileName === 'undefined' || feature.ImageFileName == null || feature.ImageFileName == "null" )
                {
                  return (
                    <View key={index+feature.ImageFileName}
                      onLayout={(info) =>
                        {
                          thisThing.didRenderNewsItem(feature, info.nativeEvent.layout.y)
                        }}>
                      <View style={{margin: 5, marginLeft: 15, marginRight: 15}}>
                        <View style={{flexDirection: 'row', alignItems: 'flex-start', marginTop: 10, marginBottom: 5}}>
                          <Icon name={thisThing.props.featureData.icon.replace("fa-", "")} size={20}/>
                          <View style={{flexDirection: 'column', flex: 1, marginLeft: 10}}>
                            <ReUpText appManager={appManager} isTitle={true} style={[styles.featureTitle, {color:generalTitleColor}]}>
                              {feature.FeatureName}
                            </ReUpText>
                            <Hyperlink
                              linkStyle={{ color: '#2980b9'}}
                              onPress={(url) => {
                                var barTintColor = thisThing.props.appManager.getColorForKey("HeaderColor");
                                var tintColor = thisThing.props.appManager.getColorForKey("HeaderIconColor");
                                LinkingManager.openURL(url, tintColor, barTintColor);
                              }}
                              >
                              <ReUpText appManager={appManager} style={[styles.featureDescription, {color:generalTitleColor}]}>
                                {feature.Description}
                              </ReUpText>
                            </Hyperlink>
                            <ReUpText appManager={appManager} style={{color:generalTitleColor, fontSize: 12, marginTop: 10}}>
                              {moment(appManager.getTime(feature.Timestamp)).format("MM/DD/YYYY")}
                            </ReUpText>
                          </View>
                        </View>
                      </View>
                      <View style={[styles.divider, {backgroundColor: 'grey', marginLeft: 5, marginRight: 5}]} />
                    </View>
                  )
                }

                if( url.search("http") != 0 ) url = "https://" + url;
                return (
                  <View key={url + index}
                    onLayout={(info) =>
                      {
                        thisThing.didRenderNewsItem(feature, info.nativeEvent.layout.y)
                      }}>
                    <View style={{margin: 5, marginLeft: 15, marginRight: 15}}>
                      <Image style={[styles.featureImage, {height}]} source={{uri: url}}/>
                      <View style={{flexDirection: 'row', alignItems: 'flex-start', marginTop: 10, marginBottom: 5}}>
                        <Icon name={thisThing.props.featureData.icon.replace("fa-", "")} size={20}/>
                        <View style={{flexDirection: 'column', flex: 1, marginLeft: 10}}>
                          <ReUpText appManager={appManager} isTitle={true} style={[styles.featureTitle, {color:generalTitleColor}]}>
                            {feature.FeatureName}
                          </ReUpText>
                          <Hyperlink
                            linkStyle={{ color: '#2980b9'}}
                            onPress={(url) => {
                              var barTintColor = thisThing.props.appManager.getColorForKey("HeaderColor");
                              var tintColor = thisThing.props.appManager.getColorForKey("HeaderIconColor");
                              LinkingManager.openURL(url, tintColor, barTintColor);
                            }}
                            >
                            <ReUpText appManager={appManager} style={[styles.featureDescription, {color:generalTitleColor}]}>
                              {feature.Description}
                            </ReUpText>
                          </Hyperlink>
                          <ReUpText appManager={appManager} style={{color:generalTitleColor, fontSize: 12, marginTop: 10}}>
                            {moment(appManager.getTime(feature.Timestamp)).format("MM/DD/YYYY")}
                          </ReUpText>
                        </View>
                      </View>
                    </View>
                    <View style={[styles.divider, {backgroundColor: 'grey', marginLeft: 5, marginRight: 5}]} />
                  </View>
                )
              }
            })
          }

        </ReUpScrollView>
        {
          showSocialMedia ?
            <View style={{position:'absolute', alignItems:'center', justifyContent:'center', top:this.props.extras && this.props.extras.shouldHideActionBar ? 0 : Globals.ACTION_BAR_HEIGHT, left:0, right:0, height:60, width:this.state.layout.width, backgroundColor:instructionColor, flexDirection:'row'}}>
            {
              typeof instagramFeature !== 'undefined' ?
                <ReUpIconButton style={{width:40, height:40, margin:6}}
                  appManager={appManager}
                  iconName={instagramFeature.data.icon.replace("fa-", "")}
                  iconSize={100}
                  type={7}
                  onPress={() => {
                    appActions.requestFeatureName(instagramFeature.data.name)
                  }}
                  />
              : null
            }
            {
              typeof twitterFeature !== 'undefined' ?
                <ReUpIconButton style={{width:40, height:40, margin:6}}
                  appManager={appManager}
                  iconName={twitterFeature.data.icon.replace("fa-", "")}
                  type={7}
                  onPress={() => {
                    appActions.requestFeatureName(twitterFeature.data.name)
                  }}
                  />
              : null
            }
            {
              typeof facebookFeature !== 'undefined' ?
                <ReUpIconButton style={{width:40, height:40, margin:6}}
                  appManager={appManager}
                  iconName={facebookFeature.data.icon.replace("fa-", "")}
                  type={7}
                  onPress={() => {
                    appActions.requestFeatureName(facebookFeature.data.name)
                  }}
                  />
              : null
            }
            </View>
          : null
        }
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  featureImage: {
    height:150,
    borderRadius: 2
  },
  divider: {
    height:1,
    marginBottom: 5
  }
});

Promotions.getCards = function(featureData, appActions, data)
{
  var appManager = appActions._appManager;
  var iconName = featureData.data.icon.replace("fa-", "")
  var cards = [];
  var promotions = typeof data.Features !== 'undefined' && data.Features != null ? data.Features : [];

  for( var i = 0; i < promotions.length; i++ )
  {
    var promotion = promotions[i];
    const promotionID = promotion.FeatureID;
    var didSelect = function() {appActions.requestFeatureName("Promotions", {featureID:promotionID})};
    if( typeof promotion.ImageFileName === 'undefined' || promotion.ImageFileName == null || promotion.ImageFileName == "null" )
    {
      var time = appManager.getTime(promotion.Timestamp);
      var sortOrder = (new Date()).getTime() - time;
      cards.push(
        {
          didSelect : didSelect,
          title : promotion.FeatureName,
          body1 : promotion.Description,
          body2 : "",
          icon : iconName,
          cardType : 0,
          sortOrder : sortOrder
        }
      )
      continue;
    }

    var url = promotion.ImageFileName;
    if( url.search("http") != 0 ) url = "https://" + url;
    var time = appManager.getTime(promotion.Timestamp);
    var sortOrder = (new Date()).getTime() - time;
    cards.push(
      {
        didSelect : didSelect,
        title : promotion.FeatureName,
        body1 : "",
        body2 : "",
        imageName : url,
        icon : iconName,
        cardType : 1,
        sortOrder : sortOrder
      }
    )
  }

  return cards;
}

Promotions.customDependencyKeys = ["Twitter"];
Promotions.customDataDependency = function(appManager, completion)
{
  var twitterFeatureData = appManager.getFeatureForName("Twitter");
  if ( typeof twitterFeatureData !== 'undefined' )
  {
    NetworkManager.getTwitterInfo(appManager, twitterFeatureData.data.twitter_screen_name, function(data)
    {
      var filteredData = [];
      for( var i = 0; i < data.length; i++ )
      {
        var thisData = data[i];
        var media = (typeof thisData.entities !== 'undefined') && (typeof thisData.entities.media !== 'undefined') && thisData.entities.media.length > 0 ? thisData.entities.media : [];
        var newMedia = [];
        for( var j = 0; j < media.length; j++ )
        {
          if( typeof media[j].media_url_https !== 'undefined' )
          {
            newMedia.push({media_url_https:media[j].media_url_https})
          }
        }
        filteredData.push({created_time:thisData.created_time, created_at:thisData.created_at, text:thisData.text, entities:{media:newMedia}})
      }
      appManager.setData({Twitter:filteredData}, function()
      {
        completion({Twitter:filteredData})
      })
    }, function(a){completion({})}, function(){completion({})});
  }
  else
  {
    completion({});
  }
}

Promotions.dataDependencies =
[
  "Features",
  "Instagrams"
];

module.exports = Promotions;
